import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import { Button } from 'react-bootstrap'
import { ApiProvider } from '@leverege/api-redux'
import { Text, Label } from '@leverege/ui-elements'
import { SystemActions, SystemUpdater, BreadcrumbActions, Constants } from '~/actions'

import { List, Screen, YesNoDialog, TextInput, LabelGroup, Loading } from '~/views'
import SystemItem from './SystemItem'
import NoSystemsView from './NoSystemsView'
import { TransferToProjectDialog } from '~/editors/project'
import PaginationSearch from '../utils/PaginationSearch'

import style from './style.css'

class SystemsScreen extends React.Component {

  static contextType = ApiProvider.Context
  
  static propTypes = {
    project : PropTypes.object
  }
  
  constructor( props, context ) {
    super( props, context );
    this.onEvent = this.onEvent.bind( this );
    this.onSystemChange = this.onSystemChange.bind( this );
    this.pager = new PaginationSearch( this, 'systems', ( props, opts ) => {
      this.props.dispatch( SystemActions.list( this.props.match.params.projectId, opts ) )
    } )

    this.state = { 
      selectId : null, 
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props ) 
    }
  }

  onEvent( event, item ) {
    const { match, history } = this.props
    const { host } = this.context
    if ( event === 'select' ) {
      history.push( `/project/${match.params.projectId}/system/${item.id}/device` )
    } else if ( event === SystemItem.CONTACTS_EVENT ) {
      history.push( `/project/${match.params.projectId}/system/${item.id}/users` )
    } else if ( event === SystemItem.VIEW_DEVICES_EVENT ) {
      history.push( `/project/${match.params.projectId}/system/${item.id}/device` )
    } else if ( event === SystemItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeSystem : item } )
    } else if ( event === SystemItem.TRANSFER_EVENT ) {
      this.setState( { showTransfer : true, transferItem : item } )
    } else if ( event === SystemItem.SHOW_UI_EVENT ) {
      const config = {
        ...item?.metadata?.moltenConfigOptions,
        systemId : item.id,
        imagineHost : host,
      }
      const params = new URLSearchParams()
      Object.entries( config ).forEach( ( [ key, value ] ) => { params.set( key, value ) } )
      const base = process.env.MOLTEN_UI || 'https://molten-ui.web.app'
      window.open( `${base}/${match.params.projectId}/_config?${params.toString()}` )
    }
  }

  onPromptRemoveYes = () => {
    const { removeSystem } = this.state
    this.props.dispatch( SystemActions.delete( removeSystem ) );
    this.setState( { showRemoveDialog : false, removeSystem : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeSystem : null } )
  }

  onSystemChange( event ) {

    SystemUpdater( this.props.dispatch, event.target )
      .set( event.path, event.value )
      .done();
  }

  onTransfer = ( system, toProject ) => {
    this.onSystemChange( { target : system, path : 'projectId', value : toProject.id } )
    this.setState( { showTransfer : false, transferItem : null } )
  }

  componentDidMount() {
    this.pager.loadPage( this.props )
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Systems' } ] ) )
  }

  componentWillReceiveProps( next ) {
    this.pager.loadIfNeeded( next )
  }

  onCreateSystem( ) {
    const { params } = this.props.match
    if ( params && params.projectId ) {
      this.props.dispatch( SystemActions.create( params.projectId, { name : 'My System', desc : '' } ) );
    }
  }

  render() {
    const { systems, projects } = this.props
    const { params } = this.props.match
    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()
    const projectId = params && params.projectId

    const loading = systems.status == Constants.STATUS_LOADING
    const items = systems.projectId == projectId ? this.pager.getPageItems() : []

    const { selectId, removeSystem, transferItem, showTransfer, search, start } = this.state
    const isSelected = function( item ) { return item && item.id == selectId; }

    // let list = <List className={style.list} onEvent={this.onEvent} isSelected={isSelected} noItemsView={<NoSystemsView/>}
    //                  items={items} itemView={SystemItem}/>

    const left = (
      <div className={style.left}>
        <List className={style.list}
          onEvent={this.onEvent} 
          isSelected={isSelected}
          noItemsView={loading ? null : <NoSystemsView />}
          items={items}
          itemView={SystemItem}
          itemProps={{ hideNavButtons : true }} />

        <div className={style.pagination}>
          <Pagination
            innerClass={classnames( 'pagination', style.innerPagination )}
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={this.pager.onPageChange} />
        </div>
        <Loading show={loading} message="Loading..." />
      </div>
    )

    const details = null
    let right

    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Systems</Text>
          <div style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <Label><i className="fa fa-search" /></Label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={() => { this.onCreateSystem() }}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New System
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          {left}
        </Screen.Content>

        <YesNoDialog show={this.state.showRemoveDialog} 
          title={`Remove ${removeSystem && removeSystem.name}?`}
          message={<div>Are you sure you want to delete the system and its devices?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />

        <TransferToProjectDialog objType="System"
          object={transferItem}
          projects={projects}
          show={showTransfer}
          onCancel={() => { this.setState( { showTransfer : false, transferItem : null } ) }}
          onTransfer={this.onTransfer} />
      </Screen>
    );
  }
} 

export default connect(
  state => ( {
    systems : state.systems,
    projects : state.projects
  } )
)( SystemsScreen )
